













































































































































































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import { Debounce } from 'lodash-decorators';
import axios from 'axios';
import { api } from '@/api';
import SessionReportForm from '@/components/dashboard/admin/session/SessionReportForm.vue';
import SessionReport from '@/components/dashboard/admin/session/SessionReport.vue';
import SessionDetails from '@/components/dashboard/admin/session/SessionDetails.vue';
import { State, Getter, Action, Mutation } from 'vuex-class';
import SessionMixin from '@/mixins/session';

@Component({
  components: {
    SessionReportForm,
    SessionReport,
    SessionDetails,
  },
})
export default class SessionTable extends Mixins(SessionMixin) {
  /* public sessions: any[] = []; */
  /* public sessionsLoading: boolean = true; */

  public reportDialog: boolean = false;
  public reportDialogData: any = null;

  public reportFormDialog: boolean = false;
  public reportFormData: any = null;

  public detailsDialog: boolean = false;
  public detailsDialogData: any = null;

  public totalItems: number = 0;

  get headersLocalized(): any[] {
    return [
      {
        text: this.$t('table_headers.sessions.id'),
        value: 'id',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.family'),
        value: 'family.family_name',
        sortable: false,
        render: (value: any, item: any) => {
          return `<a href="/a/families/edit/${item.family.id}">${value}</a>`;
        },
      },
      {
        text: this.$t('table_headers.sessions.session_starts_at'),
        value: 'session_starts_at',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.session_ends_at'),
        value: 'session_ends_at',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.duration'),
        value: 'sessionLength',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.city'),
        value: 'address.city.name',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.babysitter'),
        value: 'babysitter.full_name',
        sortable: false,
        render: (value: any, item: any) => {
          return item.babysitter
            ? `<a href="/a/babysitters/edit/${item.babysitter.id}">${value}</a>`
            : '';
        },
      },
      {
        text: this.$t('table_headers.sessions.type'),
        value: 'type',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.state'),
        value: 'state',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.accepts_new_babysitter'),
        value: 'accepts_new_babysitter',
        sortable: false,
      },
      {
        text: this.$t(
          'table_headers.sessions.preferred_babysitters_unavailable_at'
        ),
        value: 'preferred_babysitters_unavailable_at',
        sortable: false,
      },
      {
        text: this.$t('table_headers.sessions.warnings'),
        value: 'warnings',
        sortable: false,
      },
      {
        text: this.$t('table_headers.shared.actions'),
        value: 'actions',
        align: 'end',
        sortable: false,
      },
    ];
  }

  public get states() {
    return [
      {
        text: this.$t('session-states.canceled'),
        value: 'canceled',
      },
      {
        text: this.$t('session-states.requested'),
        value: 'requested',
      },
      {
        text: this.$t('session-states.listed'),
        value: 'listed',
      },
      {
        text: this.$t('session-states.review'),
        value: 'review',
      },
      {
        text: this.$t('session-states.confirmed'),
        value: 'confirmed',
      },
      {
        text: this.$t('session-states.active'),
        value: 'active',
      },
      {
        text: this.$t('session-states.finished'),
        value: 'finished',
      },
      {
        text: this.$t('session-states.completed'),
        value: 'completed',
      },
    ];
  }

  public types = [
    {
      id: 1,
      name: 'daily',
    },
    {
      id: 2,
      name: 'sleepover',
    },
    {
      id: 3,
      name: 'around the clock',
    },
    {
      id: 4,
      name: 'travel',
    },
  ];

  public get orders() {
    return [
      {
        text: this.$t('table_headers.sessions.session_starts_at'),
        value: 'session_starts_at',
      },
      {
        text: this.$t('table_headers.sessions.session_ends_at'),
        value: 'session_ends_at',
      },
      /* {
                    text: this.$t('sessions.all.requested'),
                    value: 'created_at',
                }, */
      /* {
                    text: 'Updated',
                    value: 'updated_at',
                } */
    ];
  }

  public get orderTypes() {
    return [
      {
        text: this.$t('sessions.all.asc'),
        value: 'asc',
      },
      {
        text: this.$t('sessions.all.desc'),
        value: 'desc',
      },
    ];
  }

  /* public setSessions(data: any) {

            this.sessions = data.data;
            this.totalItems = data.meta.total;
        } */

  public sessionRowUpdate(updated: any) {
    /* this.sessions.forEach((session: any) => {
                if ( session.id == updated.id ) {
                    session.id = updated.id;
                    session.babysitter = updated.babysitter;
                    session.state = updated.state;
                }
            }) */
  }

  public getPayload() {
    return {
      family: this.family,
      babysitter: this.babysitter,
      type: this.type,
      state: this.state,
      page: this.currentPage,
      per_page: this.itemsPerPage,
    };
  }

  /*  public async loadSessions(): Promise<void> {

             this.sessionsLoading = true;

            let params = this.getPayload();

            await this.fetchSessions(params);

            this.setSessions(this.sessionsStore);
            this.sessionsLoading = false

            axios.get(api.path('v1.admin.sessions'), { params: params })
                .then( res => this.setSessions( res.data ))
                .finally( () => this.sessionsLoading = false );
        } */

  /* public async reloadSessions(): Promise<void> {

            this.sessionsLoading = true;

            let params = this.getPayload();

            await this.refreshSessions(params);

            this.setSessions(this.sessionsStore);
            this.sessionsLoading = false

        } */

  public showReportForm(session: any) {
    this.reportFormData = session;
    this.reportFormDialog = true;
  }

  public viewReport(session: any) {
    this.reportDialog = true;
    this.reportDialogData = session.id;
  }

  public viewDetails(session: any) {
    this.detailsDialog = true;
    this.detailsDialogData = session.id;
  }

  get filters() {
    return {
      family: this.family,
      babysitter: this.babysitter,
      type: this.type,
      state: this.state,
      orderBy: this.orderBy,
      orderSort: this.orderSort,
      startDate: this.startDate,
      endDate: this.endDate,
      id: this.id,
      city: this.city,
      itemsPerPage: this.itemsPerPage,
    };
  }

  @Watch('filters', { deep: true })
  @Debounce(500)
  onFilterValueChange() {
    this.currentPage = 1;
    this.fetchSessions();
  }

  @Watch('currentPage')
  onPageChange() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$vuetify.goTo(0);
    }
    this.fetchSessions();
  }

  @Action('sessions/setFamily') setFamily: any;
  @Getter('sessions/family') familyState: any;

  public get family(): string {
    return this.familyState;
  }

  public set family(family: string) {
    this.setFamily(family);
  }

  @Action('sessions/setBabysitter') setBabysitter: any;
  @Getter('sessions/babysitter') babysitterState: any;

  public get babysitter(): string {
    return this.babysitterState;
  }

  public set babysitter(babysitter: string) {
    this.setBabysitter(babysitter);
  }

  @Action('sessions/setType') setType: any;
  @Getter('sessions/type') typeState: any;

  public get type(): string {
    return this.typeState;
  }

  public set type(type: string) {
    this.setType(type);
  }

  @Action('sessions/setState') setState: any;
  @Getter('sessions/state') stateState: any;

  public get state(): string {
    return this.stateState;
  }

  public set state(state: string) {
    this.setState(state);
  }

  @Action('sessions/setOrderBy') setOrderBy: any;
  @Getter('sessions/orderBy') stateOrderBy: any;

  public get orderBy(): string {
    return this.stateOrderBy;
  }

  public set orderBy(orderBy: string) {
    this.setOrderBy(orderBy);
  }

  @Action('sessions/setOrderSort') setOrderSort: any;
  @Getter('sessions/orderSort') stateOrderSort: any;

  public get orderSort(): string {
    return this.stateOrderSort;
  }

  public set orderSort(orderSort: string) {
    this.setOrderSort(orderSort);
  }

  @Action('sessions/setStartDate') setStartDate: any;
  @Getter('sessions/startDate') stateStartDate: any;

  public get startDate(): string {
    return this.stateStartDate;
  }

  public set startDate(startDate: string) {
    this.setStartDate(startDate);
  }
  public startDateMenu: boolean = false;

  @Action('sessions/setEndDate') setEndDate: any;
  @Getter('sessions/endDate') stateEndDate: any;

  public get endDate(): string {
    return this.stateEndDate;
  }

  public set endDate(endDate: string) {
    this.setEndDate(endDate);
  }
  public endDateMenu: boolean = false;

  @Action('sessions/setId') setId: any;
  @Getter('sessions/id') stateId: any;

  public get id(): string {
    return this.stateId;
  }

  public set id(id: string) {
    this.setId(id);
  }

  @Action('sessions/setCity') setCity: any;
  @Getter('sessions/city') stateCity: any;

  public get city(): string {
    return this.stateCity;
  }

  public set city(city: string) {
    this.setCity(city);
  }

  @Action('sessions/setCurrentPage') setCurrentPage: any;
  @Getter('sessions/currentPage') currentPageState: any;

  public get currentPage(): number {
    return this.currentPageState;
  }

  public set currentPage(page: number) {
    this.setCurrentPage(page);
  }

  @Action('sessions/setItemsPerPage') setItemsPerPage: any;
  @Getter('sessions/itemsPerPage') itemsPerPageState: any;

  @Action('sessions/fetchSessions') fetchSessions: any;
  @Action('sessions/refreshSessions') refreshSessions: any;
  @Getter('sessions/sessions') sessions: any;
  @Getter('sessions/sessionsLoading') sessionsLoading: any;
  @Getter('sessions/total') total: any;

  @Action('sessions/connect') echoConnect: any;
  @Action('sessions/disconnect') echoDisconnect: any;

  @Action('sessions/clearPayload') clearFilters: any;

  @Getter('cities/cities') cities: any;
  @Action('cities/fetchCities') fetchCities: any;

  public get itemsPerPage(): number {
    return this.itemsPerPageState;
  }

  public set itemsPerPage(itemsPerPage: number) {
    this.setItemsPerPage(itemsPerPage);
  }

  public async mounted() {
    this.fetchCities();
    this.echoConnect();
    await this.fetchSessions();
  }

  public beforeDestroy() {
    this.echoDisconnect();
  }

  public rowClasses(item: any) {
    return {
      'warning-row': item.potential_family || item.other_warning_condition, // Add other warning conditions here
    };
  }
}
